// client/src/utils/brandPalette.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/ui/brand.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// The colours Encatar is sold in. The public pages -- landing and login --
// are seen before anyone has signed in, so they cannot take the school
// palette; they take the brochure's, and both clients take the same one.

/**
 * THE HERO GRADIENT, written once.
 *
 * It appeared in four places with four slightly different angles, which is how
 * a gradient ends up looking like a rendering bug on the one section that got
 * 160deg instead of 165deg.
 *
 * @param {number} [angle] degrees, default the brochure's own
 * @returns {string} a CSS linear-gradient
 */
export function brochureGradient(angle) {
  const a = Number.isFinite(angle) ? angle : 165;
  return `linear-gradient(${a}deg, ${BROCHURE.inkLift} 0%, ${BROCHURE.ink} 46%, ${BROCHURE.inkDeep} 100%)`;
}

/**
 * Sampled from the brochure. Named for the job each colour does rather than for
 * the colour it is, so a reprint changes the hex in one place and every surface
 * that uses it follows.
 */
export const BROCHURE = {
  // THE GROUND. Every brochure panel sits on this indigo, and it darkens
  // slightly down the page — the gradient is the identity, not the flat colour,
  // so both stops are here rather than one with a guessed shade beside it.
  ink: '#241C6B',
  inkDeep: '#1A1450',
  inkLift: '#2E2A85',

  // THE ACCENT. Gold, used for the one thing on a panel that must be read
  // first: the trial badge, a heading rule, the primary button.
  gold: '#DFAE43',
  goldDeep: '#B8862A',

  // CARDS. Cream rather than white — white cards on this indigo glare, and the
  // brochure does not use them.
  cream: '#FAF4E4',
  creamEdge: '#EFE4C8',

  // SECTION HEADERS. Two blues, lighter than the ground, that separate a band
  // from the panel it sits on without introducing a third hue.
  blue: '#1B3A8F',
  blueBright: '#1F5FBF',

  // TEXT. On the indigo ground and on the cream cards respectively. Measured,
  // not guessed: white on #241C6B is 13.6:1, and #241C6B on #FAF4E4 is 12.4:1 —
  // both far past the 4.5:1 body text needs, which is what lets the gold be
  // used purely as an accent and never as a text colour on the ground.
  onInk: '#FFFFFF',
  onInkMuted: 'rgba(255,255,255,0.76)',
  onCream: '#241C6B',
  onCreamMuted: 'rgba(36,28,107,0.72)',

  // The line that separates bands on the indigo ground.
  rule: 'rgba(255,255,255,0.14)',
};
